import React from 'react';
import { useTranslation } from 'react-i18next';

import { CountingCirclesRecord, IssueCandidate, Result } from 'api/api.types';
import CandidateBar from 'lib/CandidateBar/CandidateBar';
import VoterInfos from 'lib/VoterInfos/VoterInfos';
import { appendRemainingVotesEntry } from '../poll/CandidateBarsCanton';

interface Props {
  municipality: CountingCirclesRecord;
  candidateList: IssueCandidate[];
  round: number;
  isFinal: boolean;
}

const ElectionAccordeon = ({ candidateList, municipality, round, isFinal }: Props) => {
  const { t } = useTranslation('wap');

  if (!municipality.candidates[0].results) return null;

  const getMunicipalityCandidates = (candidates: IssueCandidate[], results: Result) => {
    return appendRemainingVotesEntry(
      [...candidates.sort((a, b) => b.results.votes - a.results.votes)],
      results,
      t('single_votes'),
      round,
      !isFinal, // if overall election count is ongoing, we want to show the remaining votes as elected (blue), like the rest of the candidates
    );
  };

  const getMaxVotes = (muni: CountingCirclesRecord) =>
    Math.max(...muni.candidates.map(({ results }) => results.votes));

  // On level of municipalities, candidate list only contains id - name-key does not exist.
  // Therefore, we create a list with the required info here
  const isQuerydataWithoutDetails =
    !('first_name' in municipality.candidates[0]) ||
    !('is_up_to_now' in municipality.candidates[0]);

  // prettier-ignore
  const candidatesWithDetails = isQuerydataWithoutDetails
    ? candidateList?.map((candidate) => ({
      firstName: candidate.first_name,
      lastName: candidate.last_name,
      id: candidate.id,
      isUpToNow: candidate.is_up_to_now,
      partyAffiliation: candidate.party_affiliation,
    }))
    : undefined;

  return (
    <>
      <div className="accordioncontent__info">
        <VoterInfos
          eligibleVoters={municipality?.results?.eligible_voters}
          participation={municipality?.results?.participation}
        />
      </div>
      <ol className="candidatebarmunicipalities__bars">
        {getMunicipalityCandidates(municipality.candidates, municipality.results).map(
          (candidate) => (
            <li key={`${candidate.id}-${municipality.id}`}>
              <CandidateBar
                candidate={candidate}
                candidateDetails={candidatesWithDetails}
                isFinal
                maxVotes={getMaxVotes(municipality)}
              />
            </li>
          ),
        )}
      </ol>
    </>
  );
};

export default ElectionAccordeon;
